import { render, staticRenderFns } from "./TreatmentSetting.vue?vue&type=template&id=28c43953&scoped=true"
import script from "./TreatmentSetting.vue?vue&type=script&lang=js"
export * from "./TreatmentSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c43953",
  null
  
)

export default component.exports